// Utility helpers for working with PostgREST embedded public_profiles results.
// When embedding a VIEW via foreign key, PostgREST may return an array instead of an object.

export type PublicProfileEmbedded = {
  username?: string | null;
  avatar_id?: number | null;
} | null;

export function getEmbeddedPublicProfile(value: unknown): PublicProfileEmbedded {
  if (!value) return null;
  if (Array.isArray(value)) {
    return (value[0] as any) ?? null;
  }
  if (typeof value === "object") {
    return value as any;
  }
  return null;
}
